import { useState } from "react"

export const AutosizeTextarea = (props: any) => {
  const [value, setValue] = useState(props.value || "")

  const handleChange = (e: any) => setValue(e.target.value)

  return (
    <div className="autosize-textarea" data-replicated-value={value}>
      <textarea {...props} onChange={handleChange}>
        {value}
      </textarea>
    </div>
  )
}
